import body from './teenagers-body.json';
import diseasesConditions from './teenagers-diseasesConditions.json';
import drugsAlcohol from './teenagers-drugsAlcohol.json';
import expertAnswers from './teenagers-expertAnswers.json';
import foodExercise from './teenagers-foodExercise.json';
import infections from './teenagers-infections.json';
import mind from './teenagers-mind.json';
import schoolWork from './teenagers-schoolWork.json';
import sexualHealth from './teenagers-sexualHealth.json';
import sports from './teenagers-sports.json';
import staySafe from './teenagers-staySafe.json';

export const teenagers = { body, diseasesConditions, drugsAlcohol, expertAnswers, foodExercise, infections, mind, schoolWork, sexualHealth, sports, staySafe };
